import React, { Component } from 'react';
class AutoTransferAppCh extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="mgt-30 faq-container">
            <div className="text-center block-title">
              <h2 className="common-title">TRIAM Auto Transfer</h2>
              <span>version: 1.0.4.1</span>
            </div>
            <div className="content">
              <section className="opening">
                <div className="intro">
                  什么是Auto Transfer的功能？当您的电子钱包超过设定的数量时，多余的数量将自动转入另一个电子钱包的一种功能。<br />
                  例如 在接收顾客支付代币的电子等钱包中设置此功能，既可以防止电子钱包中过余额，并且提高安全性。
                </div>
                <div className="example">
                  <p>例）</p>
                  <ul className="list">
                    <li>
                      <div className="text">
                        <span>①「接收顾客支付代币的电子钱包」进行Auto Transfer的功能设置</span>
                        <span style={{ marginLeft: '25px' }}>设置的代币：RIA</span>
                        <span style={{ marginLeft: '25px' }}>设置代币的数量：500,000RIA</span>
                        <span style={{ marginLeft: '25px' }}>转送的电子钱包：「顾客支付管理电子钱包」</span>
                      </div>
                    </li>
                    <li>
                      <div className="text">
                        <span>② 顾客对「接收顾客支付代币的电子钱包」进行发送代币</span>
                        <span>当（接收顾客支付代币的电子钱包）内的余额超过了您所设置数量的时候 多余的代币数量将自动转移至（顾客支付管理电子钱包）中。</span>
                      </div>
                    </li>
                  </ul>
                  <div class="img">
                    <img src="/images/app/auto-transfer-des-ch.png" alt="Auto Transfer Des" />
                  </div>
                </div>
              </section>
              <hr />
              <section className="guide guide-1">
                <h3><b>Auto Transfer功能的设置顺序</b></h3>
                <ul className="step-guide decimal">
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>① 请登录账号后点击菜单画面右下角显示的 「Settings」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s1.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>② 滚动点击「Auto Transfer」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s2.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>③ 点击「Setup Auto Transfer」。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s3.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>1. Wallet & Asset</b></span>
                        <span>④ 设置标题 和选择电子钱包。</span>
                        <span><b>Name</b>…请输入你要Auto Transfer的说明。</span>
                        <span>※请确认内容 更改时会成为标记</span>
                        <span><b>Source wallet</b>…请选择设置Auto Transfer功能的电子钱包。</span>
                        <span><b>Min amount</b>…请输入Source wallet持有的余额最大的数量。</span>
                        <span><b>Asset</b>…请选择代币的数量。</span>
                        <span>全部输入完毕后请点击「Next」按钮。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s4.png" alt="Auto Transfer S3" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>2. Destination & Amount</b></span>
                        <span>⑤ 启用Auto Transfer功能时请先选择代币转发对方的电子钱包（Destination Wallet）。</span>
                        <span><b>･Select destination from your wallets</b></span>
                        <span><b>→</b>如果同一个账号里的电子钱包请从这里选择</span>
                        <span><b>･Enter the destination</b></span>
                        <span><b>→</b>不同账号内的电子钱包请从这里选择。请直接输入电子钱包请再次确认输入的内容后点击「Next」按钮。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s5.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                    <div className="text highlight">
                      <span>※注意</span>
                      <span>接收代币的Destination Wallet请设置无需指定Tag的电子钱包。如果Destination Wallet已经设置了必须指定Tag的交易所的电子钱包地址的情况下，Auto Transfer虽然会自动执行转送，但接收者有可能会收到一笔未知或不明的资金。请注意。</span>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>3. Review</b></span>
                        <span>⑥ 下一页为已经设置的Auto Transfer的功能的顺序画面可 以进行确认。</span>
                        <span>确认后请点击「Next」按钮。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s6.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>4. Confirm</b></span>
                        <span>⑦ 将会显示最终确认画面，请确认后点击「Confirm」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s7.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑧ 请输入OP密码后 点击「Confirm」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s8.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑨ 请输入Google双重身份验证后点击「Confirm」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s9.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>5. Done</b></span>
                        <span>⑩ 设置完成后将如左图所示。</span>
                        <span>点击菜单画面中的「Done」键返回。</span>
                        <span>Auto Transfe的设置已完成。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s10.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
              <section className="guide guide-2">
                <h3 style={{ marginBottom: '10px' }}><b>更改Auto Transfer功能的设置及步骤。</b></h3>
                <span>可以更改Auto Transfer的各种功能。</span>
                <ul className="step-guide decimal">
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>① 点击菜单画面右下角的「Settings」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s1.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>② 滚动点击「Auto Transfer」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s12.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>③ 请点击您要更改的Auto Transfer。</span>
                        <span>※可以按已设置的名称区分Auto Transfer。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s13.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>④Auto Transfer的详细画面。</span>
                        <span>❶ 记录…可以查看代币的转送记录</span>
                        <span>❷ 编辑…可以进行更改名称，代币余额最大量和转送接收方的电子钱包(Destination Wallet)</span>
                        <span>如果设置内容进行更改的请点击❷进行更改。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s14.png" alt="Auto Transfer S3" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑤ 可以进行更改标题和电子钱包。</span>
                        <span><b>･Name</b>…可以更改已经设置的Auto Transfer内容。</span>
                        <span><b>･Select destination from your wallets</b></span>
                        <span>→如果同一个账号里的电子钱包请从这里选择。</span>
                        <span><b>･Enter the destination</b></span>
                        <span>→如果不同账号内的电子钱包请直接输入电子钱包地址。</span>
                        <span><b>･Amount</b>…可以更改持有代币余额最大数量。</span>
                        <span>所有的输入完毕后请点击「Save」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s15.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑥ 请输入OP密码后 点击「Confirm」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s8.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑦ 请输入Google的双重身份验证后点击「Confirm」键。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s9.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑧ 显示左侧的画面，即更改已完成。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s18.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoTransferAppCh;



// WEBPACK FOOTER //
// ./src/containers/auto-transfer-app-ch.jsx